module.exports = __webpack_public_path__ + "static/img/eua_flag.10b9a42.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/eua_flag.png
// module id = d0tz
// module chunks = 1